<template>
    <div
        v-if="show"
        v-bind:class="parenClass"
        class="paren" />
</template>
<script>
    import { getClassSuffix } from "Formula/metadata";
    export default {
        inject: ["formulaControl", "expressionControl"],
        props: {
            left: { type: Boolean, required: false, default: false }
        },
        computed: {
            show() {
                return (
                    !this.formulaControl.simple ||
                    !this.expressionControl.isRoot ||
                    this.expressionControl.alwaysShowParens
                );
            },
            parenClass() {
                const classObject = {
                    leftParen: this.left,
                    leftParenThin: this.left && this.formulaControl.simple,
                    rightParen: !this.left,
                    rightParenThin: !this.left && this.formulaControl.simple
                };

                if (!this.formulaControl.inViewMode) {
                    const suffix = getClassSuffix(this.expressionControl.metadata.resultType);
                    classObject["paren-" + suffix] = true;
                }

                return classObject;
            }
        }
    };
</script>
<style lang="scss" scoped>
    @use "sass:math";

    @import "./_formula-style-vars.scss";

    .paren {
        width: $paren-width;
        border-radius: ($formula-borderRadius) unquote("/") math.div($paren-width, 2);
        box-shadow: 0 0 0 0 var(--bs-gray-900);
        z-index: 0;
        color: $parens-view-color;
    }

    .leftParen {
        box-shadow: -$paren-borderThickness 0 0 0 currentColor;
        margin-right: -($paren-width - $formula-borderRadius);
        margin-left: 0.25rem;
    }

    .rightParen {
        box-shadow: $paren-borderThickness 0 0 0 currentColor;
        margin-left: -($paren-width - $formula-borderRadius);
        margin-right: 0.25rem;
    }

    .leftParenThin {
        box-shadow: -$paren-thinBorderThickness 0 0 0 var(--bs-gray-900);
        margin-right: -($paren-width - $formula-borderRadius + 2px);
    }

    .rightParenThin {
        box-shadow: $paren-thinBorderThickness 0 0 0 var(--bs-gray-900);
        margin-left: -($paren-width - $formula-borderRadius + 2px);
    }
    .paren-numeric {
        color: $numeric-color;
    }
    .paren-boolean {
        color: $boolean-color;
    }
    .paren-string {
        color: $string-color;
    }
    .paren-date {
        color: $date-color;
    }
</style>
